// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","links":"Footer_links__vUbnJ","footer_header":"Footer_footer_header__V7BPx"};